<template>
  <Modal
    data-testid="session-timeout-modal"
    :heading="$t('session-timeout.heading')"
    @close-model="methods.closeModal"
  >
    <template v-slot:body>
      <div class="pt-4">
        <p>{{ $t('session-timeout.text') }}</p>
        <div class="text-xl text-primary" data-testId="session-time-left">
          {{ timeLeft }}
        </div>
      </div>
    </template>
    <template v-slot:action-buttons>
      <Button
        data-testid="continue-session-button"
        :text="$t('session-timeout.continue')"
        theme="full"
        @click="methods.closeModal"
      />
      <Button
        class="mr-3"
        data-testid="logout-button"
        :text="$t('session-timeout.logout')"
        @click="methods.logout"
      />
    </template>
  </Modal>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  inject,
  onMounted,
  onUnmounted,
} from 'vue';
import Button from '@/components/general/Button.vue';
import Modal from '@/components/general/Modal.vue';
import { Auth0ComputedState } from '@/services/integrations/auth0/types';
import { RoutePath } from '@/enums/Routes';
import { getConfig } from '@/services/config';

export default defineComponent({
  name: 'SessionTimeoutModal',
  emits: ['close-modal'],
  components: {
    Button,
    Modal,
  },
  setup(_, { emit }) {
    const auth = inject('auth') as Auth0ComputedState;

    const timeout = getConfig('logoutTimeout');
    let logoutTimer: number;
    let countdownInterval: number;

    const logout = () => {
      const currentRoute =
        window.location.protocol + '//' + window.location.host;
      auth.methods.logout({ returnTo: currentRoute + RoutePath.LOGGED_OUT });
    };

    const closeModal = () => {
      emit('close-modal');
    };

    const minutesLeft = ref(
      Math.floor((timeout % (1000 * 60 * 60)) / (1000 * 60))
    );
    const secondsLeft = ref(Math.floor((timeout % (1000 * 60)) / 1000));

    const timeLeft = computed(() => {
      const minutes = minutesLeft.value.toString().padStart(2, '0');
      const seconds = secondsLeft.value.toString().padStart(2, '0');

      return `${minutes}:${seconds}`;
    });

    onMounted(() => {
      logoutTimer = setTimeout(() => {
        logout();
      }, timeout);

      countdownInterval = setInterval(() => {
        if (secondsLeft.value > 0) {
          secondsLeft.value--;
        } else if (secondsLeft.value == 0 && minutesLeft.value > 0) {
          secondsLeft.value = 59;
          minutesLeft.value--;
        }
      }, 1000);
    });

    onUnmounted(() => {
      clearTimeout(logoutTimer);
      clearInterval(countdownInterval);
    });

    return { timeLeft, methods: { closeModal, logout } };
  },
});
</script>
